import React from "react";
import DynamicFaIcon from "../../atoms/DynamicFaIcon";

interface ButtonItemAccountProps {
  title: string;
  src: string;
  onClick?: () => void;
}

const ButtonItemAccount = (props: ButtonItemAccountProps) => {
  const { onClick, src, title } = props;

  return (
    <>
      <div
        onClick={onClick}
        className="flex items-center justify-between my-4 pr-3 gap-4 cursor-pointer hover:bg-gray-100 hover:rounded-full"
      >
        <div className="icon">
          <img src={src} alt="" height={40} width={40} />
        </div>
        <div className="text-left flex-1">
          <span className="menu-text">{title}</span>
        </div>
        <i>
          <DynamicFaIcon name={"FaAngleRight"} />
        </i>
      </div>
    </>
  );
};

export default ButtonItemAccount;
